var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grid-dots",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    strokeWidth: 2.5,
    stroke: "#2c3e50",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.fb3373ab4ba5170613417830ab179694.svg";
export { ForwardRef as ReactComponent };